import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Field } from 'redux-form';

import ButtonLoader from 'components/core/loader/button-loader';

import { renderField, renderFieldWG, renderFieldChangeWG } from '../../../utils/formUtils';

export const ProfileForm = (props) => {

    const {
        handleSubmit,
        userProfileLoading,
        asyncChangeCallback,
        submitData,
        asyncLoad,
        togglePassword,
        normalizePhone
    } = props;

    return (<Form onSubmit={ handleSubmit(submitData) } className={ 'profile-edit-info' }>
        <div className="profile-personal-info">
            <Field
                name="firstName"
                label="First Name:"
                type="text"
                component={ renderFieldWG }
                maxLength="150"
                disabled={ userProfileLoading }
                placeholder='Enter your first name'
            />
            <Field
                name="lastName"
                label="Last Name:"
                type="text"
                component={ renderFieldWG }
                maxLength="150"
                disabled={ userProfileLoading }
                placeholder='Enter your last name'
            />
            <Field
                name="userName"
                label="User Name:"
                type="text"
                handleChange={ asyncChangeCallback }
                component={ renderFieldChangeWG }
                maxLength="150"
                disabled={ userProfileLoading }
                withoutTouch={ true }
                placeholder='Enter your user name'
            />
            { asyncLoad && <div className="small-up-loader">
                <div className="lds-facebook"><div></div><div></div><div></div></div>
            </div> }

            <Form.Group controlId="formBasicEmail">
                <Form.Label>Password:</Form.Label>
                <div className="password-wrap">
                    <Field
                        name="password"
                        label="password"
                        type="password"
                        component={ renderField }
                        maxLength="150"
                        disabled={ userProfileLoading }
                        placeholder='Enter your password'
                    />

                    <span onClick={ togglePassword } className="password-swap">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.12 14.12C13.8454 14.4147 13.5141 14.6511 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1961C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4858 9.58525 10.1546 9.88 9.87999M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68189 3.96914 7.6566 6.06 6.05999L17.94 17.94ZM9.9 4.23999C10.5883 4.07887 11.2931 3.99833 12 3.99999C19 3.99999 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19L9.9 4.23999Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M1 1L23 23" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </span>
                </div>
            </Form.Group>
            <Field
                name="phone"
                label="Phone number:"
                type="text"
                component={ renderFieldWG }
                disabled={ userProfileLoading }
                placeholder='Enter your phone number'
                normalize={ normalizePhone }
            />
            <div className="form-group displayInline">
                <ButtonLoader
                    loadingText={ 'Saving' }
                    button={ <Button type="submit" variant="primary">Save</Button> }
                    loading={ userProfileLoading }
                />
            </div>
        </div>
    </Form>)
}

ProfileForm.propTypes = {
    handleSubmit: PropTypes.func,
    userProfileLoading: PropTypes.func,
    asyncChangeCallback: PropTypes.func,
    submitData: PropTypes.func,
    asyncLoad: PropTypes.func,
    togglePassword: PropTypes.func,
    normalizePhone: PropTypes.func,
};